import { createSlice } from '@reduxjs/toolkit'
import { notInitialized } from 'react-redux/es/utils/useSyncExternalStore';

const initialState = {
    window:[
        {
            windowID: 'about-me-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'About Me',
            reset: false,
        },
        {
            windowID: 'projects-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'Projects',
            reset: false,
        },
        {
            windowID: 'resume-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'Résumé',
            reset: false,
        },
        {
            windowID: 'contact-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'Contact',
            reset: false,
        },
        {
            windowID: 'canvas-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'Canvas',
            x: 25,
            y: 10,
            reset: false,
        },
        {
            windowID: 'feed-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'Feed Me',
            reset: false,
        },
        {
            windowID: 'vis-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'Visuals',
            reset: false,
        },
        {
            windowID: 'media-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'Media',
            reset: false,
        },
        {
            windowID: 'webcam-window',
            display: 'none',
            zIndex: 2,
            focus: false,
            title: 'Webcam',
            reset: false,
        },
    ],
    taskList:[],
    newWindow: false,
    startMenu: false,
}

export const mwSelectSlice = createSlice({
    name: 'shower',
    initialState,
    reducers:{

        startWindow: (state, action) => {
            const indexOfWindow = initialState.window.indexOf(initialState.window.find((w) => w.windowID === action.payload)); 
            state.window[indexOfWindow].windowID = action.payload 
            state.window[indexOfWindow].display = 'inline' 
            state.window[indexOfWindow].reset = false 
            state.newWindow = true;
            state.taskList = [...state.taskList, action.payload]
        },
        showWindow: (state, action) =>{
            const indexOfWindow = initialState.window.indexOf(initialState.window.find((w) => w.windowID === action.payload)); 
            state.window[indexOfWindow].windowID = action.payload 
            state.window[indexOfWindow].display = 'inline' 
        },
        hideWindow: (state, action) =>{
            const indexOfWindow = initialState.window.indexOf(initialState.window.find((w) => w.windowID === action.payload)); 
            state.window[indexOfWindow].windowID = action.payload 
            state.window[indexOfWindow].display = 'none' 
            state.window[indexOfWindow].focus = false
        },
 
        focusWindow: (state, action) =>{
            var nextZI = 0;
            var noFocusYet = true;
            var pressIsRepeat = false;
            const indexOfWindow = initialState.window.indexOf(initialState.window.find((w) => w.windowID === action.payload)); 
            var focusedIndex = -1;
            //loop through state.window and find the largest z-index and check if refocus is needed.
            for(let i =0; i < initialState.window.length;i++){
                //find the largest z-index value
                if(state.window[i].zIndex > nextZI){
                    nextZI = state.window[i].zIndex;
                }
                //if a new window is opened, set window with focus (focus=true) to unfocus (focus=false)
                if(state.newWindow){
                    state.window[i].focus = false;
                }else{//else, find current focus or if current window clicked is focused indicate repeated window press.
                    if(state.window[i].focus  && state.window[i].windowID !== state.window[indexOfWindow].windowID){//current focused window found
                        focusedIndex = i;
                        noFocusYet = false
                    }else if(state.window[i].focus  && state.window[i].windowID === state.window[indexOfWindow].windowID){// pressed window is already focused.
                        pressIsRepeat = true;
                    }
                }
            }
            if(state.newWindow){//if new window, update that window's z-index and set it to be focused
                state.window[indexOfWindow].zIndex = nextZI + 1
                state.window[indexOfWindow].focus = true
            }else{
                if(focusedIndex !== -1 ){//if focused window found, set the newly pressed window to be focused and update z-index. Update the last focused window to be unfocused.
                    state.window[indexOfWindow].zIndex = nextZI + 1
                    state.window[indexOfWindow].focus = true
                    state.window[focusedIndex].focus = false
                }else if(noFocusYet && !pressIsRepeat){//triggers when pressing a window right after closing the highest z-index window.
                    state.window[indexOfWindow].zIndex = nextZI + 1
                    state.window[indexOfWindow].focus = true
                }
            }


            state.newWindow = false;
        },

        closeWindow: (state, action) =>{
            const indexOfWindow = initialState.window.indexOf(initialState.window.find((w) => w.windowID === action.payload)); 
            //state.window[indexOfWindow].windowID = action.payload 
            state.window[indexOfWindow].reset = true 
            state.window[indexOfWindow].bodyWith = '500px'
            state.window[indexOfWindow].bodyHeight = '270px'
            state.window[indexOfWindow].display = 'none' 
            state.window[indexOfWindow].zIndex = 2 
            state.window[indexOfWindow].focus = false
            
            const taskListindex = state.taskList.indexOf(action.payload);
            state.taskList.splice(taskListindex, 1);
            //state.taskList = [...state.taskList]
            // if(state.taskList.length != 0){
            //     const indexOfLastFocus = state.window.indexOf(state.window.find((w) => w.windowID === state.taskList[state.taskList.length-1]))
            //     console.log(indexOfLastFocus)
            //     state.window[indexOfLastFocus].focus = true 
            // }
        },

        showStartMenu: (state, action) => {
            state.startMenu = true
        },
        hideStartMenu: (state, action) => {
            state.startMenu = false
        }
    }
})

export const { startWindow, showWindow, hideWindow, focusWindow, fullScreen, closeWindow, showStartMenu, hideStartMenu } = mwSelectSlice.actions

export default mwSelectSlice.reducer    